export const env = {
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL as string,
    loginBaseUrl: import.meta.env.VITE_LOGIN_BASE_URL as string,
    oidcRedirectUri: import.meta.env.VITE_OIDC_REDIRECT_URI as string,
}

for (const [k, v] of Object.entries(env)) {
    if (!v) throw new Error(`Missing env var: ${k}`)
}
